import { ReactNode, MouseEventHandler } from "react";
import { Button, Tooltip } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

interface ProfileSettingRowProps {
  label: ReactNode;
  value: ReactNode;
  editOnClick?: MouseEventHandler<HTMLButtonElement>;
  tooltipText?: string | null;
  testId?: string;
  isReadOnly?: boolean;
}

const ProfileSettingRow = ({
  label,
  value,
  editOnClick,
  tooltipText,
  testId = "",
  isReadOnly = false,
}: ProfileSettingRowProps) => {
  const { l10n } = useLocalization();
  const buttonLabel = l10n.getString(
    value
      ? "settings-user-card-edit-field-button"
      : "settings-user-card-add-field-button",
    {},
    value ? "Edit" : "Add"
  );

  return (
    <div className="profile-setting-row" data-testid={testId}>
      <div className="profile-setting-field">
        <div className="profile-setting-label">
          {label}
          {tooltipText && (
            <>
              {" "}
              <Tooltip text={tooltipText}>
                <span className="narmi-icon-info"></span>
              </Tooltip>
            </>
          )}
        </div>
        <div>{value}</div>
      </div>
      {!isReadOnly && (
        <Button
          kind="plain"
          label={buttonLabel}
          size="m"
          onClick={editOnClick}
        />
      )}
    </div>
  );
};

export default ProfileSettingRow;
